import { createClient } from '@supabase/supabase-js';
import { createLocalAuthClient } from './localAuthClient';

// CHANTIER « HORS SUPABASE » : tout le site n'utilise de ce client que `supabase.auth` (les donnees et les fichiers passent par
// l'API du serveur depuis le 2026-10-18). Avec REACT_APP_AUTH_BACKEND=local, `supabase.auth` est remplace par le client du serveur
// (localAuthClient.js), qui offre la meme interface : aucun des ~46 appels existants ne change. Sans ce reglage, c'est Supabase
// comme avant. Le choix se fait a la CONSTRUCTION du site (variable REACT_APP_*), donc se defait en reconstruisant.
export const AUTH_LOCAL = process.env.REACT_APP_AUTH_BACKEND === 'local';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Meme garde-fou que services/compositionApi.js : une adresse d'API abimee (MSYS qui transforme /api en chemin Windows) ne doit
// pas rendre l'authentification muette.
const adresseApi = () => {
  const configuree = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
  return /^(https?:\/\/|\/)/.test(configuree) ? configuree : '/api';
};

export const supabase = AUTH_LOCAL
  ? { auth: createLocalAuthClient({ apiBaseUrl: adresseApi() }) }
  : createClient(supabaseUrl, supabaseAnonKey);
